export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10312.7872ac8b.jpg";